<template>
    <div class="">
      home page
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        props: {},
        computed: {},
        components: {},
        methods: {},
        watch: {},
        /**
         * 创建前状态
         */
        beforeCreate() {
        },
        /**
         * 创建完毕状态
         */
        created() {
        },
        /**
         * 挂载前状态
         */
        beforeMount() {
        },
        /**
         * 挂载结束状态
         */
        mounted() {
        },
        /**
         * 更新前状态
         */
        beforeUpdate() {
        },
        /**
         * 更新完成状态
         */
        updated() {
        },
        /**
         * 销毁前状态
         */
        beforeDestroy() {
        },
        /**
         * 销毁完成状态
         */
        destroyed() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue